var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50491 5.60248C8.36241 5.60248 8.21988 5.55 8.10738 5.4375L5.71488 3.045L3.32238 5.4375C3.10488 5.655 2.74488 5.655 2.52738 5.4375C2.30988 5.22 2.30988 4.86 2.52738 4.6425L5.31741 1.85248C5.42241 1.74748 5.56488 1.6875 5.71488 1.6875C5.86488 1.6875 6.00741 1.74748 6.1124 1.85248L8.90238 4.6425C9.11988 4.86 9.11988 5.22 8.90238 5.4375C8.78988 5.55 8.64741 5.60248 8.50491 5.60248Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71484 16.3125C5.40734 16.3125 5.15234 16.0575 5.15234 15.75V2.25C5.15234 1.9425 5.40734 1.6875 5.71484 1.6875C6.02234 1.6875 6.27734 1.9425 6.27734 2.25V15.75C6.27734 16.0575 6.02234 16.3125 5.71484 16.3125Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.627 16.3116C13.477 16.3116 13.3345 16.2516 13.2295 16.1466L10.4395 13.3566C10.222 13.1391 10.222 12.7791 10.4395 12.5616C10.657 12.3441 11.017 12.3441 11.2345 12.5616L13.627 14.9541L16.0194 12.5616C16.2369 12.3441 16.597 12.3441 16.8145 12.5616C17.032 12.7791 17.032 13.1391 16.8145 13.3566L14.0245 16.1466C13.9195 16.2516 13.7695 16.3116 13.627 16.3116Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6191 16.3125C13.3116 16.3125 13.0566 16.0575 13.0566 15.75V2.25C13.0566 1.9425 13.3116 1.6875 13.6191 1.6875C13.9266 1.6875 14.1816 1.9425 14.1816 2.25V15.75C14.1816 16.0575 13.9341 16.3125 13.6191 16.3125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sort-icon.a9ed3dfaa8c76ffbc01905872ad2300f.svg";
export { ForwardRef as ReactComponent };